import React from 'react';
import PropTypes from 'prop-types';
import ExpandMore from '@material-ui/icons/ExpandMore';

import {
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core';

const ExpansionSection = ({
  children,
  defaultExpanded,
  divider,
  expanded,
  summary,
  onChange,
}) => (
  <Accordion
    defaultExpanded={defaultExpanded}
    expanded={expanded}
    onChange={onChange}
  >
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Typography>
        {summary}
      </Typography>
    </AccordionSummary>
    {divider && <Divider />}
    <AccordionDetails>
      {children}
    </AccordionDetails>
  </Accordion>
);

ExpansionSection.propTypes = {
  children: PropTypes.node.isRequired,
  defaultExpanded: PropTypes.bool,
  divider: PropTypes.bool,
  expanded: PropTypes.bool,
  summary: PropTypes.node.isRequired,
  onChange: PropTypes.func,
};

export default ExpansionSection;
